"use client";

import {NeoButton} from "@/components/forms";
import {useEffect, useState} from "react";
import toast from "react-hot-toast";
import {AiOutlineLoading} from "react-icons/ai";

interface Driver {
  name: string;
  avatar: string;
  userid: string;
}

interface AssignDriverProps {
  datas: {
    driverdetails: Driver[];
  };
  onSubmit: (data: any) => void;
}

export function AssignDriver({datas, onSubmit}: AssignDriverProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDriverId, setSelectedDriverId] = useState<string | null>(null);
  const [drivers, setDrivers] = useState<Driver[]>([]);

  useEffect(() => {
    setDrivers(datas.driverdetails);
  }, [datas]);

  const filteredDrivers = drivers.filter(driver =>
    driver.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedDriverId) {
      const requestdata: any = {
        driverId: selectedDriverId,
        assign: true
      };
      onSubmit(requestdata);
    } else {
      toast.error("Please select a driver");
    }
  };

  return (
    <div className="">
      <h2 className="mb-3 text-lg font-semibold">Existing Driver</h2>
      <div className="relative mb-4">
        <input
          type="text"
          placeholder="Search Driver"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="w-full rounded-full border border-gray-300 py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <svg
          className="absolute left-3 top-2.5 h-4 w-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-4.35-4.35M16 10a6 6 0 11-12 0 6 6 0 0112 0z"
          />
        </svg>
      </div>
      <form onSubmit={handleFormSubmit}>
        <div className="mb-4 max-h-60 overflow-y-auto pr-1">
          <ul className="space-y-3">
            {filteredDrivers.length > 0 ? (
              filteredDrivers.map((driver, index) => (
                <li
                  key={index}
                  onClick={() =>
                    setSelectedDriverId(
                      selectedDriverId === driver.userid ? null : driver.userid
                    )
                  }
                  className={`flex cursor-pointer items-center space-x-3 rounded-md p-2 
                    ${
                      selectedDriverId === driver.userid
                        ? "bg-blue-100"
                        : "hover:bg-gray-100"
                    }`}
                >
                  <img
                    src={driver.avatar}
                    alt={driver.name}
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  <span className="text-sm font-medium text-gray-800">
                    {driver.name}
                  </span>
                </li>
              ))
            ) : (
              <li className="text-center text-sm text-gray-500">
                No matching drivers
              </li>
            )}
          </ul>
        </div>
        <div className="flex justify-center">
          <NeoButton
            className="mr-4"
            type="submit"
            spinner={
              <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
            }
          >
            Submit
          </NeoButton>
          <NeoButton
            type="reset"
            color="white"
            onPress={() => setSelectedDriverId(null)}
          >
            Cancel
          </NeoButton>
        </div>
      </form>
    </div>
  );
}
